export function isValidFabrication(f) {
  return f.path || f.voids || ["function", "generic"].includes(f.type);
}

export function isEdgeFabrication(f) {
  return isValidFabrication(f) && f.position === "edge";
}

export function isCornerFabrication(f) {
  return isValidFabrication(f) && f.position === "corner";
}

export function isEdgeAlignedFabrication(f) {
  return isValidFabrication(f) && f.position === "edge-aligned";
}
